
import { Component, Vue, Prop } from 'vue-property-decorator';
import api from '@/api';
import Swal from 'sweetalert2';

const { exchanger } = api;

@Component({
  components: { },
})
export default class ExchangerCurrencyList extends Vue {
  @Prop({}) exchangerId!: string;

  private data = { data: [] };

  private headers = [
    { text: '虛擬貨幣', value: 'currencyName' },
    { text: '最高匯率', value: 'highExchangeRate' },
    { text: '最低匯率', value: 'lowExchangeRate' },
    { text: '匯率', value: 'exchangeRate' },
    { text: '手續費', value: 'serviceFee' },
    { text: '手續費百分比', value: 'serviceFeePercentage' },
    { text: '修改', value: 'edit' },
    { text: '刪除', value: 'delete' },
  ];

  private get collection() {
    return [...(this.data.data || [])];
  }

  private async handleDelete(currencyId: string, currencyName: string) {
    await Swal.fire(
      {
        title: `確定要在此交易所刪除${currencyName}嗎 ?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '確定',
        cancelButtonText: '取消',
      },
    ).then(async (result) => {
      if (result.isConfirmed) {
        const { status, message } = await exchanger.deleteCurrency(this.exchangerId, currencyId);
        if (status === 1) {
          await Swal.fire({ icon: 'success', title: '刪除成功' });
          await this.requestData();
        } else {
          await Swal.fire({ icon: 'warning', title: message });
        }
      }
    });
  }

  private async requestData() {
    const { data } = await exchanger.currencyList(this.exchangerId, { pageSize: 0, pageNo: 1 });
    this.data = data;
  }

  private async created() {
    await this.requestData();
  }
}
